module.exports = require('../build/addons/MomentLocaleUtils');



/*****************
 ** WEBPACK FOOTER
 ** ./~/react-day-picker/moment/index.js
 ** module id = 3271
 ** module chunks = 0
 **/